import React from "react";
interface IHead {
  title: string;
  width: number;
}
interface ICustomTable<T> {
  headers: IHead[];
  data: T[];
  renderItem: (item: T) => React.ReactNode;
  actions: (item: T) => React.ReactNode;
}

export const CustomTable = <T,>({
  headers,
  data,
  renderItem,
  actions,
}: ICustomTable<T>) => {
  return (
    <table className="custom-table">
      <thead>
        <tr>
          {headers.map((value: IHead, index: number) => (
            <th key={index} style={{ width: value.width }}>
              {value.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((value: T, index) => {
          return (
            <tr key={index}>
              {renderItem(value)}
              <td>{actions(value)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
